var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-searchform", class: _vm.getTheme }, [
    _c(
      "form",
      {
        attrs: {
          action: "/search",
          method: "get",
          autocomplete: "off",
          "accept-charset": "UTF-8",
        },
      },
      [
        _c("div", { staticClass: "c-searchform__input_container" }, [
          _c("input", {
            attrs: {
              placeholder: _vm.placeholder,
              "aria-label": _vm.placeholder,
              type: "text",
              name: "query",
            },
            domProps: { value: _vm.query },
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              attrs: { type: "submit", role: "button", "aria-label": "search" },
            },
            [_c("uc-icon", { attrs: { title: "Search", glyph: "search" } })],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }